export default function Footer (){
   
   
    return (
        <footer>
        <div className="container--big-row">
            <div className="footer-container">
                <div className="footer-list">
                    <div className="footer-item">
                        <h3>MAIN</h3>
                        <ul className="footer-item-list">
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Blog</a></li>
                        <li><a href="#FAQS" className="footer_link  footer_link-line ">FAQs</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Support</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">About Us</a></li> 
                         </ul>
                    </div>
                    <div className="footer-item">
                        <h3>PRODUCT</h3>
                        <ul className="footer-item-list">
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Log in</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Personal</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Business</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Team</a></li> 
                         </ul>
                    </div>
                    <div className="footer-item">
                        <h3>PRESS</h3>
                        <ul className="footer-item-list">
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Logo</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Events</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Stories</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Office</a></li> 
                         </ul>
                    </div>
                    <div className="footer-item">
                        <h3>TEAM</h3>
                        <ul className="footer-item-list">
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Career</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Founders</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Culture</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Onboarding</a></li> 
                         </ul>
                    </div>
                    <div className="footer-item">
                        <h3>LEGAL</h3>
                        <ul className="footer-item-list">
                        <li><a href="" className="footer_link no-cursor footer_link-line ">GDPR</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line ">Privacy Policy</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Terms of Service</a></li>
                        <li><a href="" className="footer_link no-cursor footer_link-line">Disclaimer</a></li> 
                         </ul>
                    </div>
                </div>
                 <hr className="footer--linespace"/>
                 <div className="footer-bottom">
                 <div className="logo">
                <figure className="logo__container"><img className="footer-logo" src='paw.png' alt="Meow Hosting Icon"/></figure>
                <h4> Meow Hosting Inc.</h4>   
                </div>
                <span>&copy; Meow Hosting Inc.  All rights reserved.</span>
                <div className="footer--buttons-group">
                    <button className="footer--button no-cursor"><i class="fa-brands fa-facebook-f"></i></button>
                    <button className="footer--button no-cursor"><i class="fa-brands fa-twitter"></i></button>
                    <button className="footer--button no-cursor"><i class="fa-brands fa-youtube"></i></button>
                </div>
                 </div>
                 </div>
            </div>

        </footer>
        )
}